module.exports = __webpack_public_path__ + "img/32656.ee938a08.png";